import algoliasearch from 'algoliasearch/lite';
import { formatedDate, truncateString, locale } from '../alpine-functions';
import { CREDENTIALS as AlgoliaCredantials } from '../config/algolia';

const LIMIT = 12;
const BASE_URL = '/api/collections/blog_posts/entries';
const FIELDS = 'url,title,perex,hero_image,date';
const ASSET_API = '/api/v1/assets';

export default (searchEnabled = false) => ({
  posts: [],
  page: 1,
  totalPages: 0,
  initialPosts: [],
  searchEnabled: searchEnabled,
  indexBlogPosts: {},
  searching: false,
  loading: false,
  currentUrl: window.location.pathname,
  currentLocale: locale(),
  filter: {
    query: '',
    methodic: '',
    field: '',
  },
  filterActive: false,

  get algoliaClient() {
    return algoliasearch(AlgoliaCredantials.app, AlgoliaCredantials.key);
  },

  init() {
    this.getPosts();
    if (this.searchEnabled) {
      return this.initAlgoliaIndex('BLOG_POSTS');
    }
    return this.getPosts();
  },

  get getInititalPosts() {
    return this.initialPosts.slice(12);
  },

  initAlgoliaIndex(index) {
    this.indexBlogPosts = this.algoliaClient.initIndex(index);
  },

  getPosts() {
    return fetch(
      `${BASE_URL}?limit=${LIMIT}&page=${this.page}&fields=${FIELDS}&sort=-date&filter[url:not]=${this.currentUrl}&filter`
    )
      .then((response) => response.json())
      .then((response) => {
        this.initialPosts = [...this.initialPosts, ...response.data];
        this.totalPages = response.meta.last_page;
      });
  },

  hasPosts() {
    return this.posts.length > 0;
  },

  formatedDate(date) {
    return formatedDate(date);
  },

  getHeroImage(post) {
    if (!post.hero_image_cached_path) {
      return post.hero_image_url;
    }
    const http = new XMLHttpRequest();

    http.open('HEAD', post.hero_image_cached_path, false);
    http.send();

    if (http.status != 404) {
      return post.hero_image_cached_path;
    }

    return `${ASSET_API}?id=${post.hero_image_id}`;
  },

  getPerex(perex = '') {
    return truncateString(perex, 123);
  },

  searchQuery() {
    this.filterActive = true;
    const filter = this.filter;

    if (
      filter.query.length < 3 &&
      !filter.methodic &&
      !filter.field
    ) {
      this.searching = false;
      this.filterActive = false;
      this.indexBlogPosts.search('', { hitsPerPage: 1000 }).then(({ hits }) => {
        this.posts = hits.filter(post => {
          if (!post.site) return true;
          const siteHandle = typeof post.site === 'object' ? post.site.handle : post.site;
          return siteHandle === this.currentLocale;
        });
      });
      return;
    }

    this.searching = true;
    this.loading = true;

    this.indexBlogPosts.search(filter.query, { hitsPerPage: 1000 }).then(({ hits }) => {
      let retPosts = hits;

      retPosts = retPosts.filter((post) => {
        if (!post.site) {
          return true;
        }
        const siteHandle = typeof post.site === 'object' ? post.site.handle : post.site;
        const matches = siteHandle === this.currentLocale;
        return matches;
      });

      if (filter.methodic) {
        retPosts = retPosts.filter((post) => {
          const methodics = Array.isArray(post.methodics)
            ? post.methodics
            : (post.methodics ? [post.methodics] : []);
          const audits_categories = Array.isArray(post.audits_categories)
            ? post.audits_categories
            : (post.audits_categories ? [post.audits_categories] : []);
          return methodics.includes(filter.methodic) || audits_categories.includes(filter.methodic);
        });
      }

      if (filter.field) {
        retPosts = retPosts.filter((post) => {
          const fields = Array.isArray(post.fields)
            ? post.fields
            : (post.fields ? [post.fields] : []);
          return fields.includes(filter.field);
        });
      }

      this.posts = retPosts;
      this.loading = false;
    });
  },

  resetFilter() {
    this.filter.query = '';
    this.filter.methodic = '';
    this.filter.field = '';
    this.filterActive = false;
    this.searching = false;
    this.loading = false;
    this.$nextTick(() => {
      $('select.form-input').each((index, item) => {
        item.sumo.reload();
      });
    });
  },
});
